import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { BlockEditorContent, DotCMSURLContentMap } from '@dotcms/types';
import { Observable } from 'rxjs';

import { DotCmsUveFacade } from '../../../facades/dot-cms-uve.facade';
import { Author, BlogContentlet, ContentletImage } from '../../../models/dot-cms-uve-contentlet.model';
import { DotCmsUveEditablePageService } from '../../../services/dot-cms-uve-editable-page/dot-cms-uve-editable-page.service';
import { DotCmsBlogPageComponent } from '../dot-cms-uve-blog-detail-page/dot-cms-uve-blog-detail-page.component';

export interface BlogContentlets extends CustomDotCMSURLContentMap {
  blogContent: BlockEditorContent;
  image: ContentletImage;
  author: Author;
}

export interface CustomDotCMSURLContentMap extends DotCMSURLContentMap {
  type?: string;
  URL_MAP_FOR_CONTENT: string;
  urlMap: string;
}

// export interface BlogPageAsset extends DotCMSPageAsset {
//   urlContentMap: BlogContentlet;
// }

// type BlogPage = {
//   pageAsset: BlogPageAsset;
//   content: ExtraContent;
// };

@Component({
  selector: 'custom-dot-cms-blog-detail',
  providers: [DotCmsUveEditablePageService],

  templateUrl: './dot-cms-uve-blog-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DotCmsBlogPageComponent],
})
export class DotCmsBlogDetailComponent {
  // Expose $pageState (initialized in ngOnInit)
  urlContentMap = signal<BlogContentlet>(null);
  private readonly dotCmsUveFacade = inject(DotCmsUveFacade);

  readonly $pageState = this.dotCmsUveFacade.pageState;

  host$: Observable<string>;

  constructor() {
    effect(() => {
      this.urlContentMap.set(this.$pageState()?.pageResponse?.pageAsset?.urlContentMap as unknown as BlogContentlet);
    });
  }
}
